import React, { useEffect, useState } from 'react'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { useNavigate, useOutletContext } from 'react-router'
import { createSearchParams } from 'react-router-dom'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import {
  EMP_CHECK_LIST_RESIGN_ADMIN,
  EMP_CHECK_LIST_RESIGN_IT,
  EMP_CHECK_LIST_RESIGN_PD
} from '../../../router/routes'
import { BsArrowClockwise, BsSearch, BsSliders2Vertical } from 'react-icons/bs'
import NavMenuLayout from './nav-menu'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { Controller, useForm } from 'react-hook-form'

import ModalCustom from '../../modal-custom'
import LabelCustom from '../../label-custom'
import Autocomplete from '../../custom/autocomplete'
import { useSelector } from 'react-redux'
import { getChecklistResignAPI } from '../../../services/checklist'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import TableListResign from './resigns/table-list'
// import moment from 'moment'
import { BODYCLR, PAGECLR } from '../../../Constants'
import UseChecklistStatus from '../../../hooks/use-checklist-status'
import PickerRangeCustom from '../../datepicker-between-custom'
import { fnDateEn } from '../../../helper/fnDateEn'

// ต้องเปลี่ยนชื่อ statusId เป็น statusId ทั้งหมดใน CLR
export default function CheckListResignsPage() {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm()

  const navigate = useNavigate()
  const optionStatus = UseChecklistStatus()

  const orgId = useSelector((state) => state.roleReducer.role)
  const [statusId, setStatusId] = useState(1)

  const [totalPage, setTotalPages] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(20)
  const [isLoading, setIsLoading] = useState(true)

  const [dataChecklist, setDataChecklist] = useState([])
  const dateFormat = 'MMMM YYYY'
  const [showFilter, setShowFilter] = useState(false)

  const handleClose = () => setShowFilter(false)
  const handleShow = () => setShowFilter(true)
  const [monthYear, setMonthYear] = useState('')

  const bodyQuery = JSON.parse(localStorage.getItem(BODYCLR))
  const [bodyFilter, setBodyFilter] = useState()

  const pageOld = localStorage.getItem(PAGECLR)
  const [page, setPage] = useState(pageOld ?? 1)
  const [sortDoc, setSortDoc] = useState(false)
  const [sortCode, setSortCode] = useState(false)
  const [sortLastDate, setSortLastDate] = useState(false)
  const [sortName, setSortName] = useState(false)
  const [clickedColumn, setClickedColumn] = useState(null)

  useEffect(() => {
    if (optionStatus.length > 0 && orgId !== '') {
      if (orgId !== bodyQuery?.orgId) {
        const d = {
          page: 1,
          orgId,
          statusId: 1
        }
        setPage(1)
        setStatusId(1)
        getChecklistResign(d)
      } else if (bodyQuery) {
        setPage(bodyQuery?.page ?? 1)
        setMonthYear(bodyQuery?.monthYear)

        setValue('searchs', bodyQuery?.searchs)
        setValue('lastDate', [
          bodyQuery?.lastDateFirst ?? '',
          bodyQuery?.lastDateLast ?? ''
        ])
        setClickedColumn(bodyQuery.sortBy)
        setSortCode(bodyQuery.order !== 'asc' ? true : false)

        setStatusId(bodyQuery?.statusId ?? '')

        getChecklistResign(bodyQuery)
      }
    }
  }, [optionStatus, orgId])
  async function getChecklistResign(body, order, sortBy, statusId) {
    try {
      if (orgId) {
        const param = {
          ...body,
          size: totalLimits,
          order,
          sortBy
        }
        localStorage.setItem(BODYCLR, JSON.stringify(param))

        setBodyFilter(param)
        setIsLoading(true)
        const resp = await getChecklistResignAPI(param)
        setIsLoading(false)
        if (!resp) return
        if (resp.status) {
          setDataChecklist(resp.result ?? [])
          setTotalPages(resp.totalPages)
          setTotalRows(resp.totalRows)
          setTotalLimits(resp.totalLimits)
        } else {
          Error_false(resp)
          setDataChecklist([])
          setTotalPages(0)
          setTotalRows(0)
          setTotalLimits(20)
        }
      }
    } catch (error) {
      setIsLoading(false)
      Error_500(error)
    }
  }

  const handleSortDoc = (column) => {
    setClickedColumn(column)

    if (sortDoc) {
      setSortDoc(false)
      getChecklistResign({ ...bodyFilter, page: 1 }, 'asc', 'clnNo')
    } else {
      setSortDoc(true)
      getChecklistResign({ ...bodyFilter, page: 1 }, 'desc', 'clnNo')
    }
    setPage(1)
  }
  const handleSortCode = (column) => {
    setClickedColumn(column)

    if (sortCode) {
      setSortCode(false)
      getChecklistResign({ ...bodyFilter, page: 1 }, 'asc', 'code')
    } else {
      setSortCode(true)
      getChecklistResign({ ...bodyFilter, page: 1 }, 'desc', 'code')
    }
    setPage(1)
  }
  const handleSortLastDate = (column) => {
    setClickedColumn(column)

    if (sortLastDate) {
      setSortLastDate(false)
      getChecklistResign({ ...bodyFilter, page: 1 }, 'asc', 'lastDate')
    } else {
      setSortLastDate(true)
      getChecklistResign({ ...bodyFilter, page: 1 }, 'desc', 'lastDate')
    }
    setPage(1)
  }
  const handleSortName = (column) => {
    setClickedColumn(column)

    if (sortName) {
      setSortName(false)
      getChecklistResign({ ...bodyFilter, page: 1 }, 'asc', 'name')
    } else {
      setSortName(true)
      getChecklistResign({ ...bodyFilter, page: 1 }, 'desc', 'name')
    }
    setPage(1)
  }

  const onChangeMonth = (date, dateString) => {
    const body = {
      ...bodyFilter,
      orgId,
      page: 1,
      statusId,
      monthYear: dateString ? fnDateEn(date).format('YYYYMM') : ''
    }
    setPage(1)
    setMonthYear(body.monthYear)
    getChecklistResign(body)
  }

  const onSubmit = (d) => {
    const body = {
      orgId,
      page: 1,
      searchs: d.searchs,
      statusId,
      monthYear,
      lastDateFirst: d.lastDate && d.lastDate.length > 0 ? d.lastDate[0] : '',
      lastDateLast: d.lastDate && d.lastDate.length > 0 ? d.lastDate[1] : ''
    }
    setPage(1)
    getChecklistResign(body)
    handleClose()
  }
  const hadleClickIT = (d) => {
    navigate(
      {
        pathname: EMP_CHECK_LIST_RESIGN_IT,
        search: `?${createSearchParams({
          code: d.code,
          org: d.org_id,
          id: d.clr_no
        })}`
      },
      { replace: true }
    )
  }

  const hadleClickPD = (d) => {
    navigate(
      {
        pathname: EMP_CHECK_LIST_RESIGN_PD,
        search: `?${createSearchParams({
          code: d.code,
          org: d.org_id,
          id: d.clr_no
        })}`
      },
      { replace: true }
    )
  }

  const hadleClickAdmin = (d) => {
    navigate(
      {
        pathname: EMP_CHECK_LIST_RESIGN_ADMIN,
        search: `?${createSearchParams({
          code: d.code,
          org: d.org_id,
          id: d.clr_no
        })}`
      },
      { replace: true }
    )
  }

  const clearSearch = () => {
    reset()

    const body = {
      orgId,
      page: 1,
      statusId: 1,
      monthYear: ''
    }
    setPage(1)
    setMonthYear('')
    setStatusId(1)
    getChecklistResign(body)
  }

  const onSearch = (d) => {
    const body = {
      orgId,
      page: 1,
      searchs: d.searchs,
      statusId,
      monthYear,
      order: bodyFilter.order,
      sortBy: bodyFilter.order
    }

    setPage(1)
    getChecklistResign(body)
  }

  return (
    <>
      <div className="p-3 ">
        <Row>
          <Col xl={12}>
            <div className="d-flex  justify-content-between  ">
              <NavMenuLayout />
              {orgId ? (
                <div className="justify-content-end my-auto gap-2 ps-0 d-flex">
                  <Form onSubmit={handleSubmit(onSearch)}>
                    <Form.Group className="" style={{ minWidth: 300 }}>
                      <Controller
                        name={'searchs'}
                        control={control}
                        render={({ field: { onChange, value = '' } }) => (
                          <InputGroup className="">
                            <InputGroup.Text className="bg-white border-end-0  text-muted">
                              <BsSearch />
                            </InputGroup.Text>
                            <Form.Control
                              value={value}
                              placeholder="Doc No./ Code/ Name/ Nickname"
                              onChange={onChange}
                              className="border-start-0 ps-0 placeholder-text"
                            />
                          </InputGroup>
                        )}
                      />
                    </Form.Group>
                  </Form>

                  <DatePicker
                    style={{ minWidth: '160px' }}
                    value={monthYear ? dayjs(monthYear) : ''}
                    className=""
                    format={dateFormat}
                    picker="month"
                    onChange={onChangeMonth}
                  />

                  <div
                    className=""
                    style={{
                      width: '150px',
                      position: 'sticky',
                      top: 0,
                      zIndex: 999
                    }}
                  >
                    <Autocomplete
                      placeholder={`Status`}
                      options={optionStatus}
                      value={
                        optionStatus.length > 0
                          ? optionStatus.find((item) => item.value === statusId)
                          : ''
                      }
                      onChange={(data) => {
                        setStatusId(data.value)
                        const body = {
                          orgId,
                          page: 1,
                          statusId: data.value,
                          searchs: bodyFilter.searchs ?? '',
                          lastDateFirst: bodyFilter.lastDateFirst ?? '',
                          lastDateLast: bodyFilter.lastDateLast ?? '',

                          monthYear
                        }

                        setPage(1)
                        getChecklistResign(body)
                      }}
                    />
                  </div>

                  <Button
                    size="sm"
                    className="text-primary"
                    type="button"
                    variant="light"
                    style={{ minWidth: '100px' }}
                    onClick={handleShow}
                  >
                    <BsSliders2Vertical className="me-2" /> Filter
                  </Button>
                  <Button
                    size="sm"
                    type="button"
                    variant="light"
                    onClick={() => clearSearch()}
                    className="text-primary"
                  >
                    <BsArrowClockwise />
                  </Button>
                </div>
              ) : (
                <></>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div className="overflow-auto">
        <TableListResign
          orgId={orgId}
          dataChecklist={dataChecklist}
          page={page}
          totalLimits={totalLimits}
          isLoading={isLoading}
          hadleClickIT={hadleClickIT}
          hadleClickPD={hadleClickPD}
          hadleClickAdmin={hadleClickAdmin}
          getChecklistResign={getChecklistResign}
          sortDoc={sortDoc}
          sortCode={sortCode}
          sortLastDate={sortLastDate}
          sortName={sortName}
          handleSortDoc={handleSortDoc}
          handleSortCode={handleSortCode}
          handleSortLastDate={handleSortLastDate}
          handleSortName={handleSortName}
          clickedColumn={clickedColumn}
          statusId={statusId}
        />
      </div>
      <div className="pt-3">
        <PaginationControl
          page={page}
          total={totalRows}
          limit={totalLimits}
          changePage={(p) => {
            const body = {
              orgId,
              page: p,
              statusId,
              searchs: bodyFilter.searchs ?? '',
              lastDateFirst: bodyFilter.lastDateFirst ?? '',
              lastDateLast: bodyFilter.lastDateLast ?? '',
              monthYear
            }
            setPage(p)
            getChecklistResign(body)
          }}
          ellipsis={1}
        />
      </div>

      <ModalCustom width={400} open={showFilter} onCancel={handleClose}>
        <h4>Filter</h4>
        <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
          <Row style={{ rowGap: '15px' }}>
            <Col md={12}>
              <LabelCustom text={'Search'} />
              <Controller
                name={'searchs'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    onChange={onChange}
                    placeholder="Code / Name/ Nickname"
                    style={{ opacity: 0.7, fontSize: 14 }}
                  />
                )}
              />
            </Col>

            <Col md={12}>
              <LabelCustom text="Last Date" />
              <Controller
                name={'lastDate'}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <PickerRangeCustom
                    value={value}
                    onChange={(date) => {
                      if (date.length > 1) {
                        const st = fnDateEn(date[0]).format('YYYY-MM-DD')
                        const en = fnDateEn(date[1]).format('YYYY-MM-DD')
                        onChange([st, en])
                      } else if (date.length === 0) {
                        onChange(['', ''])
                      }
                    }}
                  />
                )}
              />
            </Col>

            <Col xl={12} md={12} className="align-self-end text-center mt-4">
              <Button
                style={{ width: '130px' }}
                variant="secondary"
                type="button"
                className=" px-4 bg-white text-secondary me-3"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className=" px-4"
                style={{ width: '130px' }}
              >
                Apply
              </Button>
            </Col>
          </Row>
        </Form>
      </ModalCustom>
    </>
  )
}
